// extracted by mini-css-extract-plugin
export default {"main":"PrivateLayout_main__M3Q68"};